import React, { useState, useEffect } from "react";
import Enumerable from "linq";

//material mui components
import {
  Autocomplete,
  Grid,
  TextField,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Tooltip,
  Typography
} from "@mui/material";

//icons
import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined";
import StarIcon from "@mui/icons-material/Star";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

//Utilidades
import { useGlobalState } from "../../../../Utilidades/useGlobalState";
import { MostrarMensaje } from "../../../../Utilidades/ManejoMensajes";
import {
  ValidarPropiedad,
  ValidarFormatoCorreo,
} from "../../../../Utilidades/ValidarPropiedades";

//components
import { ActionTitleAndButtons } from "../ActionTitleAndButtons";
import { MOBILE } from "../../config";

//actions
import { enlistaArrayCodigosMensajesIdiomas } from "../../../../Actions/Generales/IdiomasAction";
import {
  ObtenerTablaRegistros,
  CrearNuevoRegistro,
  ActualizarRegistro,
  EliminarRegistro,
  EstablecerFavorito,
} from "../../../../Actions/Clientes/ClientesCorreosAction";

//styles
import {
  styleTable,
  StyleHome,
} from "../../../Tool/Style";

//styled components
import {
  StyledTableCellClass,
  StyledTableRowClass,
  StyledTableRowHeaderClass,
} from "../../../../theme/themeTableRow";

/**
 *
 * @param {{ deviceIs: "DESKTOP" | "MOBILE" | "TABLET" }} param0
 * @returns
 */
function CorreosClientes({ deviceIs = "DESKTOP", DatosContactoInfo }) {
  const {
    CodigoVerificado,
    ListCamposRequeridos,
    Credenciales,
    TipoCorreo,
    ListTiposCorreos,
    ElimenarRegistro,
  } = DatosContactoInfo;


  const [registro, setRegistro] = useState({
    id: "00000000-0000-0000-0000-000000000000",
    text: "",
  });

  const { etiquetas, codigoIdioma, dispatch } = useGlobalState();

  const [Correo, setCorreo] = useState({
    CustomerEmailId: "00000000-0000-0000-0000-000000000000",
    CustomerId: Credenciales.customerId,
    EmailTypeId:
      ListTiposCorreos.length > 0
        ? ListTiposCorreos[0].id
        : "00000000-0000-0000-0000-000000000000",
    Email: "",
    Observation: "",
    CompanyId: Credenciales.companyId,
    UserId: Credenciales.userId,
  });

  const [listEmails, setListEmails] = useState([]); // se encarga del recolectar el listado de correos

  useEffect(() => {
     LoadEmailTable();
  }, [codigoIdioma]);

  useEffect(() => {
    if (registro.id !== "00000000-0000-0000-0000-000000000000") {
      ElimenarRegistro(registro.text, eliminaCorreo);
    }
  }, [registro.id]);

  const LoadEmailTable = async () => {
    const objetoListar = {
      CustomerId: Credenciales.customerId,
      UserId: Credenciales.userId,
    };
    const responseEmailTable = await ObtenerTablaRegistros(objetoListar);
    if (responseEmailTable.status === 200) {
      //si la respuesta fue existosa
      setListEmails(responseEmailTable.data);
    } else {
      if (responseEmailTable.data.errors) {
        const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
          responseEmailTable.data.errors
        );
        MostrarMensaje(
          dispatch,
          responseEmailTable.data.typeError,
          arrayErrores
        );
      } else {
        MostrarMensaje(dispatch, "error", [responseEmailTable.statusText]);
      }
      setListEmails([]);
    }
  };

  const ingresarValoresMemoria = (e) => {
    const { name, value } = e.target; // se desestructura del targen el nombre y el valor que trae

    // se usa el hook de useState sobre la variable de estado local y se actualiza solo la propiedad que concuerda con el
    // valor que se le envia lo demas se queda igual
    setCorreo((anterior) => ({
      ...anterior,
      [name]: value,
    }));
  };

  function salvarCorreo() {
    const objetoCorreo = {
      CustomerEmailId: Correo.CustomerEmailId,
      CustomerId: Correo.CustomerId,
      EmailTypeId: Correo.EmailTypeId,
      Email: Correo.Email,
      Observation: Correo.Observation,
      CompanyId: Credenciales.companyId,
      UserId: Credenciales.userId,
    };

    let validacionCampos = ValidarPropiedad(
      ListCamposRequeridos,
      objetoCorreo,
      dispatch
    );

    if (
      validacionCampos &&
      Correo.Email !== "" &&
      ValidarFormatoCorreo(Correo.Email) !== true
    ) {
      MostrarMensaje(dispatch, "warning", ["ErrorValidEmailFormat"]);
      validacionCampos = false;
    }

    if (validacionCampos) {
      dispatch({
        type: "LOAD_CLIENT",
        texto: etiquetas.CargandoModal.Et_Procesando,
      });
      if (Correo.CustomerEmailId !== "00000000-0000-0000-0000-000000000000") {
        ActualizarRegistro(objetoCorreo).then((response) => {
          if (response.status === 200) {
            //si la respuesta fue existosa
            LoadEmailTable();
            NuevoCorreo();
            MostrarMensaje(dispatch, "success", ["updateOk"]);
          } else {
            if (response.data.errors) {
              const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
                response.data.errors
              );
              MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
            } else {
              MostrarMensaje(dispatch, "error", [response.statusText]);
            }
          }
        });
        dispatch({ type: "CLOSE_LOAD_CLIENT" });
      } else {
        CrearNuevoRegistro(objetoCorreo).then((response) => {
          if (response.status === 200) {
            //si la respuesta fue existosa
            LoadEmailTable();
            NuevoCorreo();
            MostrarMensaje(dispatch, "success", ["insertOk"]);
          } else {
            if (response.data.errors) {
              const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
                response.data.errors
              );
              MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
            } else {
              MostrarMensaje(dispatch, "error", [response.statusText]);
            }
          }
        });
        dispatch({ type: "CLOSE_LOAD_CLIENT" });
      }
    }
  }

  function NuevoCorreo() {
    setCorreo({
      CustomerEmailId: "00000000-0000-0000-0000-000000000000",
      CustomerId: Credenciales.customerId,
      EmailTypeId:
        ListTiposCorreos.length > 0
          ? ListTiposCorreos[0].id
          : "00000000-0000-0000-0000-000000000000",
      Email: "",
      Observation: "",
      CompanyId: Credenciales.companyId,
      UserId: Credenciales.userId,
    });
    TipoCorreo.SetInfo(
      ListTiposCorreos.length > 0
        ? {
            id: ListTiposCorreos[0].id,
            description: ListTiposCorreos[0].description,
          }
        : { id: "00000000-0000-0000-0000-000000000000", description: "" }
    );
  }

  function EditarCorreo(email) {
    setCorreo({
      CustomerEmailId: email.cumCustomerEmailId,
      CustomerId: Credenciales.customerId,
      EmailTypeId: email.cumEmailTypeIdFk,
      Email: email.cumEmail,
      Observation: email.cumObservation,
      CompanyId: Credenciales.companyId,
      UserId: Credenciales.userId,
    });
    const tipoTemp = Enumerable.from(ListTiposCorreos).firstOrDefault(
      (x) => x.id === email.cumEmailTypeIdFk
    );
    TipoCorreo.SetInfo(
      ListTiposCorreos.length > 0 && tipoTemp !== undefined
        ? tipoTemp
        : { id: "00000000-0000-0000-0000-000000000000", description: "" }
    );
  }

  function EditarCorreoFavorito(email) {
    const objetoFavorito = {
      CustomerEmailId: email.cumCustomerEmailId,
      CustomerId: Credenciales.customerId,
      CompanyId: Credenciales.companyId,
      UserId: Credenciales.userId,
    };

    EstablecerFavorito(objetoFavorito).then((response) => {
      if (response.status === 200) {
        //si la respuesta fue existosa
        LoadEmailTable();
        NuevoCorreo();
      } else {
        if (response.data.errors) {
          const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
            response.data.errors
          );
          MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
        } else {
          MostrarMensaje(dispatch, "error", [response.statusText]);
        }
      }
    });
  }

  const eliminaCorreo = async () => {
    const objetoEliminar = {
      CustomerEmailId: registro.id,
      CompanyId: Credenciales.companyId,
      UserId: Credenciales.userId,
    };

    EliminarRegistro(objetoEliminar).then((response) => {
      if (response.status === 200) {
        //si la respuesta fue existosa
        MostrarMensaje(dispatch, "success", ["deleteOk"]);
        LoadEmailTable();
        NuevoCorreo();
      } else {
        if (response.data.errors) {
          const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
            response.data.errors
          );
          MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
        } else {
          MostrarMensaje(dispatch, "error", [response.statusText]);
        }
      }
      ElimenarRegistro("", null);
    });
  };

  function ManejadorTipoEmail(id) {
    setCorreo((anterior) => ({
      ...anterior,
      EmailTypeId: id,
    }));
  }

  const ingresarValoresMemoriaAuto = (event, newValue) => {
    if (newValue === null || newValue === undefined || newValue === "") {
      TipoCorreo.SetInfo({
        id: "00000000-0000-0000-0000-000000000000",
        description: "",
      });
      ManejadorTipoEmail("00000000-0000-0000-0000-000000000000");
    } else {
      TipoCorreo.SetInfo(newValue);
      ManejadorTipoEmail(newValue.id);
    }
  };

  return (
    <React.Fragment>
      <ActionTitleAndButtons
        key={"CorreoClientes"}
        titleOption={etiquetas.InterfazClienteContactInfo.Et_tblEmailTittle}
        CodigoVerificado={CodigoVerificado}
        cleanClick={NuevoCorreo}
        deviceIs={deviceIs}
        saveClick={salvarCorreo}
      />

      <div>
        <Grid
          key="GridContactInformation"
          container
          style={deviceIs === MOBILE ? { backgroundColor:'#fff' } : StyleHome.GridConteiner}
        >
          <Grid
            item
            xs={deviceIs === MOBILE ? 12 : 4}
            sm={4}
            md={4}
            style={StyleHome.GridItem}
          >
            <Autocomplete
              disabled={CodigoVerificado === false}
              noOptionsText={etiquetas.General.Et_tblSinOpciones}
              fullWidth
              value={TipoCorreo.Info}
              name="TipoCorreo"
              options={ListTiposCorreos}
              onChange={ingresarValoresMemoriaAuto}
              getOptionLabel={(option) => option.description}
              renderInput={(params) => (
                <TextField
                  name="label"
                  {...params}
                  label={
                    Enumerable.from(ListCamposRequeridos).any(
                      (x) => x.code === "EmailTypeId"
                    )
                      ? etiquetas.InterfazClienteContactInfo.Et_tblEmailType +
                        " *"
                      : etiquetas.InterfazClienteContactInfo.Et_tblEmailType
                  }
                />
              )}
            />
          </Grid>
          <Grid
            item
            xs={deviceIs === MOBILE ? 12 : 8}
            sm={8}
            md={8}
            style={StyleHome.GridItem}
          >
            <TextField
              disabled={CodigoVerificado === false}
              error={
                ValidarFormatoCorreo(Correo.Email) === false &&
                Correo.Email !== ""
              }
              name="Email"
              value={Correo.Email}
              variant="outlined"
              fullWidth
              label={
                Enumerable.from(ListCamposRequeridos).any(
                  (x) => x.code === "Email"
                )
                  ? etiquetas.InterfazClienteContactInfo.Et_tblEmail + " *"
                  : etiquetas.InterfazClienteContactInfo.Et_tblEmail
              }
              onChange={ingresarValoresMemoria}
              inputProps={{
                maxLength: 200,
              }}
            ></TextField>
          </Grid>
          <Grid item xs={12} sm={12} md={12} style={StyleHome.GridItem}>
            <TextField
              disabled={CodigoVerificado === false}
              multiline
              name="Observation"
              value={Correo.Observation}
              variant="outlined"
              fullWidth
              rows={2}
              label={
                Enumerable.from(ListCamposRequeridos).any(
                  (x) => x.code === "Observation"
                )
                  ? etiquetas.General.Et_tblObservation + " *"
                  : etiquetas.General.Et_tblObservation
              }
              onChange={ingresarValoresMemoria}
              inputProps={{
                maxLength: 200,
              }}
            ></TextField>
          </Grid>

          <Grid item xs={12} sm={12} md={12} style={StyleHome.GridItem}>
            {deviceIs === MOBILE ? (
              <div style={{ display: "flex", flexDirection: "column" }}>
                {listEmails.length > 0
                  ? listEmails.map((registro) => (
                      <div key={registro.cumCustomerEmailId + "mobile"}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography sx={StyleHome.textPrimary}>
                            {
                              etiquetas.InterfazClienteContactInfo
                                .Et_tblEmailType
                            }
                            :
                          </Typography>

                          <Typography sx={StyleHome.textSecondary}>
                            {registro.cotDsc}
                          </Typography>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography sx={StyleHome.textPrimary}>
                            {etiquetas.InterfazClienteContactInfo.Et_tblEmail}:
                          </Typography>

                          <Typography sx={StyleHome.textSecondary}>
                            {registro.cumEmail}
                          </Typography>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography sx={StyleHome.textPrimary}>
                            {etiquetas.General.Et_tblAcciones}:
                          </Typography>

                          <div style={{display:'flex', justifyContent:'flex-end', width:'100%'}}>
                            <Tooltip title={etiquetas.General.Et_tbnFavorito}>
                              <IconButton
                                style={styleTable.BodyButtoms}
                                disabled={CodigoVerificado === false}
                                onClick={() => {
                                  if (registro.cumFavorite === false)
                                    EditarCorreoFavorito(registro);
                                }}
                              >
                                {registro.cumFavorite === false ? (
                                  <StarBorderOutlinedIcon fontSize="normal" />
                                ) : (
                                  <StarIcon fontSize="normal" />
                                )}
                              </IconButton>
                            </Tooltip>
                            <Tooltip title={etiquetas.General.Et_tbnEditar}>
                              <IconButton
                                style={styleTable.BodyButtoms}
                                disabled={CodigoVerificado === false}
                                onClick={() => EditarCorreo(registro)}
                              >
                                <EditIcon fontSize="normal" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title={etiquetas.General.Et_tbnEliminar}>
                              <IconButton
                                style={styleTable.BodyButtoms}
                                disabled={CodigoVerificado === false}
                                onClick={() => {
                                  setRegistro({
                                    id: registro.cumCustomerEmailId,
                                    text: registro.cumEmail,
                                  });
                                }}
                              >
                                <DeleteIcon fontSize="normal" />
                              </IconButton>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    ))
                  : null}
              </div>
            ) : (
              <TableContainer
                component={Grid}
                style={styleTable.TableConteiner}
              >
                <Table stickyHeader>
                  <TableHead style={styleTable.TableHeader}>
                    <StyledTableRowHeaderClass>
                      <StyledTableCellClass>
                        {etiquetas.InterfazClienteContactInfo.Et_tblEmailType}
                      </StyledTableCellClass>
                      <StyledTableCellClass>
                        {etiquetas.InterfazClienteContactInfo.Et_tblEmail}
                      </StyledTableCellClass>
                      <StyledTableCellClass width="85px" Align="center">
                        {etiquetas.General.Et_tblAcciones}
                      </StyledTableCellClass>
                    </StyledTableRowHeaderClass>
                  </TableHead>
                  <TableBody>
                    {listEmails.length > 0 ? (
                      listEmails.map((registro) => (
                        <StyledTableRowClass key={registro.cumCustomerEmailId}>
                          <StyledTableCellClass component="th" scope="row">
                            {registro.cotDsc}
                          </StyledTableCellClass>
                          <StyledTableCellClass>
                            {registro.cumEmail}
                          </StyledTableCellClass>
                          <StyledTableCellClass width="85px" Align="center">
                            <div style={styleTable.BodyContainerButtoms}>
                              <Tooltip title={etiquetas.General.Et_tbnFavorito}>
                                <IconButton
                                  style={styleTable.BodyButtoms}
                                  disabled={CodigoVerificado === false}
                                  onClick={() => {
                                    if (registro.cumFavorite === false)
                                      EditarCorreoFavorito(registro);
                                  }}
                                >
                                  {registro.cumFavorite === false ? (
                                    <StarBorderOutlinedIcon fontSize="normal" />
                                  ) : (
                                    <StarIcon fontSize="normal" />
                                  )}
                                </IconButton>
                              </Tooltip>
                              <Tooltip title={etiquetas.General.Et_tbnEditar}>
                                <IconButton
                                  style={styleTable.BodyButtoms}
                                  disabled={CodigoVerificado === false}
                                  onClick={() => EditarCorreo(registro)}
                                >
                                  <EditIcon fontSize="normal" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title={etiquetas.General.Et_tbnEliminar}>
                                <IconButton
                                  style={styleTable.BodyButtoms}
                                  disabled={CodigoVerificado === false}
                                  onClick={() => {
                                    setRegistro({
                                      id: registro.cumCustomerEmailId,
                                      text: registro.cumEmail,
                                    });
                                  }}
                                >
                                  <DeleteIcon fontSize="normal" />
                                </IconButton>
                              </Tooltip>
                            </div>
                          </StyledTableCellClass>
                        </StyledTableRowClass>
                      ))
                    ) : (
                      <StyledTableRowClass>
                        <StyledTableCellClass colSpan={3}>
                          {etiquetas.General.Et_tblTableEmty}
                        </StyledTableCellClass>
                      </StyledTableRowClass>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Grid>
        </Grid>
      </div>
    </React.Fragment>
  );
}

export default CorreosClientes;
